import React from 'react'

const About = () => {
    return (
        <main className="about-section section">
            <p>
                Lorem ipsum, dolor sit amet consectetur adipisicing elit. Officia eaque fuga ipsum est autem, pariatur nemo iusto non possimus numquam assumenda accusantium labore dolorum ullam repellat adipisci dolorem dolore sit.
            </p>
        </main>
    )
}

export default About